<template>
    <div class="preloader-area">
        <div class="preloader">
            <div class="loader">
                <div>
                    <div>
                        <div>
                            <div>
                                <div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="waviy">
                <span>F</span>
                <span>O</span>
                <span>N</span>
                <span>T</span>
                <span>E</span>
                <span>S</span>
                <span>.</span>
                <span>B</span>
                <span>U</span>
                <span>S</span>
                <span>I</span>
                <span>N</span>
                <span>E</span>
                <span>S</span>
                <span>S</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader'
}
</script>